import Vue from 'vue'
import 'vuetify/src/stylus/app.styl'
import '@fortawesome/fontawesome-pro/css/all.css' // Ensure you are using css-loader

import App from './App.vue'
import router from './router'
import store from './store'
import Vuetify from 'vuetify'
import VeeValidate from 'vee-validate';
// import Vuelidate from 'vuelidate'
import VueTheMask from 'vue-the-mask'

Vue.use(VueTheMask)
Vue.config.productionTip = false

Vue.use(VeeValidate, {
  events: 'blur|change'
})

Vue.use(Vuetify, {
  iconfont: 'fa'
})
// Vue.use(Vuelidate)

new Vue({
  router,
  store,
  render: h => h(App),
  $_veeValidate: {
    validator: 'new'
  },
}).$mount('#app')





